import React, { useState, useEffect } from "react";
import styles from "./index.module.scss";
import ClassNames from "classnames";
import { sessionNoteTypes } from "../../partials/sessionNotes";

import LinearProgress from "@material-ui/core/LinearProgress";
import SendIcon from "@material-ui/icons/Send";
import { useTranslation } from "react-i18next";

const defaultTabs = sessionNoteTypes;

export default function NotesInputGroup({ handleSend, placeholder,hasAchievedKPI,hasAchievedKPICompliment,...props }) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const [text, setText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const tabs = props.tabs ? props.tabs : defaultTabs; // uses defaultTabs if no tabs specified in props
  useEffect(()=>{
    if(hasAchievedKPI && hasAchievedKPICompliment === true){
      const complimentTab =  tabs.findIndex(tab => tab.type_id === 3);
      setActiveTab(complimentTab !== -1 ? complimentTab :0)
    }
    else{
      setActiveTab(0);
    }
  },[hasAchievedKPI])
  const initialForm = {
    noteText: "",
  };

  if (!localStorage.sessionNotes) {
    localStorage.setItem("sessionNotes", JSON.stringify(initialForm));
  }

  const localData =
    localStorage.sessionNotes && localStorage.sessionNotes !== undefined
      ? JSON.parse(localStorage.sessionNotes)
      : {};

  useEffect(() => {
    setTimeout(() => {
      setText(localData.noteText);
    }, 2000);
  }, []);

  const updateText = e => {
    setText(e.target.value);
    const tmp = JSON.parse(localStorage.sessionNotes);
    tmp.noteText = e.target.value;
    localStorage.setItem("sessionNotes", JSON.stringify(tmp));
  };

  const onSendClick = async function () {
    if (text.length > 0) {
      setIsLoading(true);
      handleSend(text, tabs[activeTab], success => {
        if (success) {
          setText(""); // reset text
          const tmp = JSON.parse(localStorage.sessionNotes);
          tmp.noteText = "";
          localStorage.setItem("sessionNotes", JSON.stringify(tmp));
        } else {
          // what else happens if fail?
        }
      });
      setIsLoading(false);
    }
  };

  return (
    <div className={ClassNames(styles.container, props.className)} {...props}>
      <div className={styles.tabs}>
        {tabs.map((tab, index) => {
          return (
            <div
              key={index}
              className={ClassNames(
                styles.tab,
                activeTab === index ? styles.active : ""
              )}
              onClick={() => {
                if (!isLoading) {
                  setActiveTab(index);
                }
              }}
            >
              <div className={styles.tabContent}>
                <div
                  className={styles.icon}
                  style={{ color: activeTab === index ? tab.color : "" }}
                >
                  {tab.icon}
                </div>
                <span
                  className={styles.label}
                  style={{ color: activeTab === index ? tab.color : "" }}
                >
                  {t(tab.label)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.textInputContainer}>
        <textarea
          placeholder={
            placeholder ? placeholder : t("createSession.addNewNote")
          }
          className={styles.textInput}
          onChange={updateText}
          disabled={isLoading}
          value={text}
          resize
        />
        <div
          className={ClassNames(
            styles.sendButton,
            text.length > 0 ? styles.showButton : "",
            isLoading ? styles.disableButton : ""
          )}
          onClick={onSendClick}
        >
          <SendIcon
            color={isLoading ? "disabled" : "inherit"}
            style={{ color: isLoading ? "" : "#0A859A" }}
          />
        </div>

        {isLoading && <LinearProgress className={styles.progressBar} />}
      </div>
    </div>
  );
}